import React, { useCallback, useEffect, useState } from "react";
import { userApi } from "@/lib/userApi";
import { MediaLightbox } from "@/components/feed/MediaLightbox";
import { ImageIcon } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Fotos recientes de la comunidad: miniaturas que abren el visor. */
export const PhotoStrip = ({ refreshKey = 0 }) => {
  const [photos, setPhotos] = useState([]);
  const [zoom, setZoom] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await userApi.get("/feed/photos", { params: { limit: 12 } });
      setPhotos(data.photos || []);
    } catch { setPhotos([]); }
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  if (photos.length === 0) return null;

  return (
    <div className="glass-card p-4" data-testid="photo-strip">
      <div className="flex items-center gap-2 mb-3">
        <ImageIcon className="w-3.5 h-3.5 text-red-400" />
        <span className="text-[11px] uppercase tracking-[0.14em] text-white/55">
          Fotos recientes
        </span>
      </div>
      <div className="grid grid-cols-4 sm:grid-cols-6 gap-1.5">
        {photos.map((m, i) => (
          <button key={m.media_id} data-testid={`strip-photo-${m.media_id}`}
            onClick={() => setZoom(i)}
            className="aspect-square rounded-lg overflow-hidden border border-white/10 hover:border-red-400/60 transition-colors">
            <img src={`${BACKEND}${m.url}`} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>

      {zoom !== null && (
        <MediaLightbox list={photos} index={zoom} onIndex={setZoom} onClose={() => setZoom(null)} />
      )}
    </div>
  );
};

export default PhotoStrip;
